import { ADD_SOCIAL_NETWORK } from './types';

export const addNetwork = network => ({
  type: ADD_SOCIAL_NETWORK,
  payload: network
});



// WEBPACK FOOTER //
// ./src/store/SocialMedia/actions.js